        const FIELD_MEANING = {
            "password (cleartext)": "the actual password in plain text — usable to sign in right now, and to try against the company's other systems",
            "password (hashed)":    "a scrambled password that can be cracked offline; assume a good share will be recovered",
            "email":                "the account address — a phishing target and the username for many logins",
            "username":             "the handle used to sign in",
            "name":                 "full name — fuel for convincing social engineering",
            "address":              "postal address — a doxxing and physical-security concern",
            "phone":                "phone number — used for SIM-swap, smishing and vishing",
            "ip_address":           "an IP address tied to the account",
        };

export { FIELD_MEANING };
